
// export const BASE_URL = "http://3hjobs.test/api/";
export const BASE_URL = 'https://3hjobs.securemail.store/api/';

//popular projects, featured projects, featured cities and top freelancers
export const LANDING_PAGE_DETAILS = `general/landing-page-details`;

// Project Payment
export const INITIATE_PROJECT_PAYMENT = `project/payment/initiate`; //#!DONE


export const ALL_MY_NOTIFICATIONS = `${BASE_URL}notifications/all`;
export const MARK_NOTIFICATION_AS_READ = `${BASE_URL}notifications/mark-as-read`;
export const DELETE_NOTIFICATION = `${BASE_URL}notifications/delete`;


// Admin
export const ALL_TRANSACTIONS = `${BASE_URL}project/payment/all_transactions`;
export const ALL_SUCCESSFUL_TRANSACTIONS = `${BASE_URL}project/payment/successful_transactions`;